import React, { useState, useEffect } from 'react';
import { RefreshCcw, Clock } from 'lucide-react';

const Navbar = ({ title = "Dashboard" }) => {
  const [lastUpdated, setLastUpdated] = useState('');

  useEffect(() => {
    const currentDate = new Date().toLocaleString();
    setLastUpdated(currentDate);
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <nav className="bg-white shadow-md rounded-lg md:my-6 md:mx-4">
      <div className="px-6 py-4 h-20 flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <span className="md:text-2xl text-xl font-bold text-gray-800">{title}</span>
          <div className="hidden md:block h-6 w-px bg-gray-300 mx-2"></div>
          <span className="hidden md:flex items-center md:text-sm text-xs text-gray-500">
            <Clock className="h-4 w-4 mr-1" />
            Last Updated: <span className="ml-1 font-medium">{lastUpdated}</span>
          </span>
        </div>

        <div className="flex items-center">
          <span className="md:hidden flex items-center text-sm text-gray-500 mr-3">
            <Clock className="h-4 w-4 mr-1" />
            <span className="font-medium">{lastUpdated}</span>
          </span>
          <button
            onClick={handleRefresh}
            className="p-2 rounded-full bg-blue-50 hover:bg-blue-100 transition-colors duration-200 flex items-center justify-center group"
            aria-label="Refresh page"
          >
            <RefreshCcw className="md:h-5 md:w-5 h-4 w-4 text-blue-600 group-hover:text-blue-700" />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;